var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 27.2606H24.1182C24.703 27.2606 25.177 26.7865 25.177 26.2018V16.6724 H5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 27.2606H7.17704C6.59227 27.2606 6.11822 26.7865 6.11822 26.2018V16.6724"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.3784C4 11.8261 4.44772 11.3784 5 11.3784H26.2941C26.8464 11.3784 27.2941 11.8261 27.2941 12.3784V15.6725C27.2941 16.2248 26.8464 16.6725 26.2941 16.6725H5C4.44772 16.6725 4 16.2248 4 15.6725V12.3784Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6465 27.2608V11.3784"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6684 8.38408C19.8942 9.77539 17.8572 10.7939 15.6797 11.3784C16.2642 9.20089 17.2827 7.1639 18.674 5.38973C20.5362 3.52902 21.5907 3.8142 22.4237 4.64149C23.2566 5.46879 23.5305 6.52338 21.6684 8.38408Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62374 8.38408C11.3981 9.77513 13.435 10.7936 15.6124 11.3784C15.0286 9.20064 14.01 7.16352 12.6181 5.38973C10.7574 3.52902 9.7028 3.8142 8.86986 4.64149C8.03691 5.46879 7.76303 6.52338 9.62374 8.38408Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftTransparent);
export default __webpack_public_path__ + "static/media/gift-transparent.511941cd7ddd7e65f068cb46ed871181.svg";
export { ForwardRef as ReactComponent };